module.exports = __webpack_public_path__ + "media/img/Landing_Page/fb-icon-7f49afebd5adbd94357b9cc9bbd3fbe8.png";